import { NodeViewWrapper } from '@tiptap/react';
import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { Flex, Text, IconButton, Icon } from '@chakra-ui/react';
import { AiIcon } from '@/assets/icons/ai';
import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { X } from '@kula-ai/icons-core';

export const AIBlockComponent = ({ ...props }) => {
  return (
    <NodeViewWrapper>
      <Flex
        bg="#F5EEF9"
        w="600px"
        h="100px"
        borderRadius="8px"
        border="1px solid #D098F0"
        data-drag-handle
        my="6px"
        alignItems="center"
        p="16px"
      >
        <Flex
          w="56px"
          minW="56px"
          h="56px"
          bg="#DBC5E8"
          borderRadius="full"
          alignItems="center"
          justifyContent="center"
        >
          <Icon as={AiIcon} width="28px" height="28px" color="#A25DC9" />
        </Flex>
        <Flex ml="16px" gap="8px" flexDir="column" w="480px" mr="36px">
          <Text fontWeight="semiBold">Dynamic AI Block</Text>
          <Text>
            This personalised block will highlight the candidate's experience,
            skills, or background as per the choice you made.
          </Text>
        </Flex>
        <IconButton
          variant="outline"
          h="36px"
          w="36px"
          icon={<Icon as={X} w="20px" h="20px" />}
          bg="#fff"
          _hover={{ background: '#fff' }}
          onClick={() => props?.deleteNode()}
        />
      </Flex>
    </NodeViewWrapper>
  );
};

export const AIBlock = Node.create({
  name: 'AiPersonalizedBlock',

  group: 'block',

  atom: true,
  draggable: true,
  parseHTML() {
    return [
      {
        tag: 'ai-personalized-block',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['ai-personalized-block', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AIBlockComponent);
  },
});

export const RemoveAIBlockOnPaste = Extension.create({
  name: 'RemoveAIBlockOnPaste',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('RemoveAIBlockOnPaste'),
        props: {
          transformPastedHTML(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Check if pasted content contains ai-personalized-block
            const personalizedBlocks = tempDiv.querySelectorAll(
              'ai-personalized-block'
            );

            personalizedBlocks.forEach((block) => {
              // Remove the node
              block.parentNode.removeChild(block);
            });

            return tempDiv.innerHTML;
          },
        },
      }),
    ];
  },
});
